export const COLOR_MAP = {
  // General
  info: 'rgb(25, 118, 210)',
  users: 'rgb(25, 118, 210)',
  profile: 'rgb(25, 118, 210)',

  // Dabsi apps
  clientell: 'rgb(156, 39, 176)',
  imminote: 'rgb(237, 108, 2)',
  botmaker: 'rgb(46, 125, 50)',
  rakine: 'rgb(21, 101, 192)',
  whatchat: 'rgb(0, 150, 136)',

  // Shared Modules
  templates: 'rgb(46, 125, 50)',

  // Clientell Modules
  clients: 'rgb(156, 39, 176)',
  groups: 'rgb(156, 39, 176)',

  // Imminote Modules
  sdk: 'rgb(237, 108, 2)',
  settings: 'rgb(237, 108, 2)',

  // Botmaker Modules
  chatbot: 'rgb(46, 125, 50)',

  // WhatChat Modules
  inbox: 'rgb(0, 150, 136)',
};

export const makeTransparent = (color: string, opacity = 0.1) => {
  // Handle hex colors
  if (color.startsWith('#')) {
    const hex = color.replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  // Handle rgb/rgba colors
  return color.slice(0, -1) + `, ${opacity})`;
};
